// import React, { useState } from "react";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";

// import { useEffect } from "react";
// import useAxios from "../../Hooks/useAxios";
// import { hasGraphPermission, hasCardPermission } from "../../Util/Permissions";
// import useApp from "../../Hooks/useApp";

// const FleetDashboard = () => {
//   const request = useAxios();
//   const { user } = useApp();

//   const [image, setImage] = useState("");

//   const fuelData = [
//     { name: "Vehicle 1", fuelUsage: 75 },
//     { name: "Vehicle 2", fuelUsage: 60 },
//     { name: "Vehicle 3", fuelUsage: 90 },
//   ];

//   const distanceData = [
//     { name: "Jan", distance: 400 },
//     { name: "Feb", distance: 800 },
//     { name: "Mar", distance: 600 },
//     { name: "Apr", distance: 1200 },
//     { name: "May", distance: 900 },
//   ];

//   const statusData = [
//     { name: "In Transit", value: 3 },
//     { name: "Available", value: 5 },
//     { name: "Maintenance", value: 2 },
//   ];

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];

//   return (
//     <div className="p-8 bg-light_grey">
//       <h1 className="text-4xl font-bold mb-8 text-primary">Fleet Dashboard</h1>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {hasCardPermission(user, "total_fuel_usage") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Total Fuel Usage</h2>
//             <p className="text-3xl font-bold text-green">2250 L</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_fuel_cost") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Fuel Cost</h2>
//             <p className="text-3xl font-bold text-secondary">$2,500</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_scheduled_maintenances") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">
//               Scheduled Maintenance
//             </h2>
//             <p className="text-3xl font-bold text-yellow">2 Vehicles</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_upcoming_dispatches") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Upcoming Dispatches</h2>
//             <p className="text-3xl font-bold text-red">5 Dispatches</p>
//           </div>
//         )}
//       </div>

//       {/* Fuel Usage Analytics */}
//       {hasGraphPermission(user, "fuel_usage_analytics") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Fuel Usage Analytics
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <BarChart data={fuelData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="name" stroke="#667080" />
//               <YAxis stroke="#667080" />
//               <Tooltip />
//               <Bar dataKey="fuelUsage" fill="#154469" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       )}

//       {/* Vehicle Status Breakdown */}
//       {hasGraphPermission(user, "vehicle_status_breakdown") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Vehicle Status Breakdown
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <Pie
//                 data={statusData}
//                 cx="50%"
//                 cy="50%"
//                 labelLine={false}
//                 label={({ name, percent }) =>
//                   `${name}: ${(percent * 100).toFixed(0)}%`
//                 }
//                 outerRadius={100}
//                 dataKey="value"
//               >
//                 {statusData.map((entry, index) => (
//                   <Cell
//                     key={`cell-${index}`}
//                     fill={COLORS[index % COLORS.length]}
//                   />
//                 ))}
//               </Pie>
//               <Tooltip />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//       )}

//       {/* Distance Traveled Over Time */}
//       {hasGraphPermission(user, "distance_traveled_over_time") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Distance Traveled Over Time
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <LineChart data={distanceData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="name" stroke="#667080" />
//               <YAxis stroke="#667080" />
//               <Tooltip />
//               <Line type="monotone" dataKey="distance" stroke="#4CAF50" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FleetDashboard;

// import React from "react";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";

// import useApp from "../../Hooks/useApp";
// import { hasGraphPermission, hasCardPermission } from "../../Util/Permissions";
// import useTable from "../../Features/Tables/FuelManagement/Provider/useTable";

// const FleetDashboard = () => {
//   const { user } = useApp();
//   const {
//     docs: fuelDocs,
//     isLoading,
//   } = useTable();

//   // Transform docs to chart-ready format
//   const fuelData = fuelDocs.map((doc, index) => ({
//     name: doc.vehicleName || `Vehicle ${index + 1}`,
//     fuelUsage: doc.fuel_amount || 0,
//   }));

//   const distanceData = [
//     { name: "Jan", distance: 400 },
//     { name: "Feb", distance: 800 },
//     { name: "Mar", distance: 600 },
//     { name: "Apr", distance: 1200 },
//     { name: "May", distance: 900 },
//   ];

//   const statusData = [
//     { name: "In Transit", value: 3 },
//     { name: "Available", value: 5 },
//     { name: "Maintenance", value: 2 },
//   ];

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];

//   return (
//     <div className="p-8 bg-light_grey">
//       <h1 className="text-4xl font-bold mb-8 text-primary">Fleet Dashboard</h1>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {hasCardPermission(user, "total_fuel_usage") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Total Fuel Usage</h2>
//             <p className="text-3xl font-bold text-green">2250 L</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_fuel_cost") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Fuel Cost</h2>
//             <p className="text-3xl font-bold text-secondary">$2,500</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_scheduled_maintenances") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Scheduled Maintenance</h2>
//             <p className="text-3xl font-bold text-yellow">2 Vehicles</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_upcoming_dispatches") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Upcoming Dispatches</h2>
//             <p className="text-3xl font-bold text-red">5 Dispatches</p>
//           </div>
//         )}
//       </div>

//       {/* Fuel Usage Analytics */}
//       {hasGraphPermission(user, "fuel_usage_analytics") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Fuel Usage Analytics
//           </h2>

//           {isLoading ? (
//             <p className="text-center">Loading fuel data...</p>
//           ) : (
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart data={fuelData}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//                 <XAxis dataKey="name" stroke="#667080" />
//                 <YAxis stroke="#667080" />
//                 <Tooltip />
//                 <Bar dataKey="fuelUsage" fill="#154469" />
//               </BarChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       )}

//       {/* Vehicle Status Breakdown */}
//       {hasGraphPermission(user, "vehicle_status_breakdown") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Vehicle Status Breakdown
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <Pie
//                 data={statusData}
//                 cx="50%"
//                 cy="50%"
//                 labelLine={false}
//                 label={({ name, percent }) =>
//                   `${name}: ${(percent * 100).toFixed(0)}%`
//                 }
//                 outerRadius={100}
//                 dataKey="value"
//               >
//                 {statusData.map((entry, index) => (
//                   <Cell
//                     key={`cell-${index}`}
//                     fill={COLORS[index % COLORS.length]}
//                   />
//                 ))}
//               </Pie>
//               <Tooltip />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//       )}

//       {/* Distance Traveled Over Time */}
//       {hasGraphPermission(user, "distance_traveled_over_time") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Distance Traveled Over Time
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <LineChart data={distanceData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="name" stroke="#667080" />
//               <YAxis stroke="#667080" />
//               <Tooltip />
//               <Line type="monotone" dataKey="distance" stroke="#4CAF50" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FleetDashboard;

// import React, { useState, useMemo } from "react";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";

// import useApp from "../../Hooks/useApp";
// import { hasGraphPermission, hasCardPermission } from "../../Util/Permissions";
// import useTable from "../../Features/Tables/FuelManagement/Provider/useTable";

// const FleetDashboard = () => {
//   const { user } = useApp();
//   const { docs: fuelDocs, isLoading } = useTable();

//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   // Filtered docs by date range
//   const filteredDocs = useMemo(() => {
//     if (!startDate || !endDate) return fuelDocs;
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     return fuelDocs.filter((doc) => {
//       const date = new Date(doc.fuel_date);
//       return date >= start && date <= end;
//     });
//   }, [startDate, endDate, fuelDocs]);

//   // Calculate total fuel used
//   const totalFuel = useMemo(() => {
//     return filteredDocs.reduce(
//       (acc, doc) => acc + (Number(doc.fuel_amount) || 0),
//       0
//     );
//   }, [filteredDocs]);

//   const totalCost = useMemo(() => {
//     return filteredDocs.reduce((acc, doc) => acc + (Number(doc.cost) || 0), 0);
//   }, [filteredDocs]);

//   // Prepare fuel usage data for chart
//   const fuelData = filteredDocs.reduce((acc, doc) => {
//     const name = doc.vehicleName || doc.vehicles.plate_no || "Unknown";
//     const existing = acc.find((item) => item.name === name);
//     if (existing) {
//       existing.fuelUsage += Number(doc.fuel_amount) || 0;
//     } else {
//       acc.push({ name, fuelUsage: Number(doc.fuel_amount) || 0 });
//     }
//     return acc;
//   }, []);

//   const statusData = [
//     { name: "In Transit", value: 3 },
//     { name: "Available", value: 5 },
//     { name: "Maintenance", value: 2 },
//   ];

//   const distanceData = [
//     { name: "Jan", distance: 400 },
//     { name: "Feb", distance: 800 },
//     { name: "Mar", distance: 600 },
//     { name: "Apr", distance: 1200 },
//     { name: "May", distance: 900 },
//   ];

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];

//   return (
//     <div className="p-8 bg-light_grey">
//       <h1 className="text-4xl font-bold mb-8 text-primary">Fleet Dashboard</h1>

//       {/* Date range filter */}
//       <div className="flex flex-wrap gap-4 mb-6 items-center">
//         <label className="flex flex-col text-sm">
//           From:
//           <input
//             type="date"
//             className="p-2 border rounded"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//           />
//         </label>
//         <label className="flex flex-col text-sm">
//           To:
//           <input
//             type="date"
//             className="p-2 border rounded"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//           />
//         </label>
//       </div>

//       {/* Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
//         {hasCardPermission(user, "total_fuel_usage") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Total Fuel Usage</h2>
//             <p className="text-3xl font-bold text-green">
//               {totalFuel.toFixed(2)} L
//             </p>
//           </div>
//         )}
//         {/* You can calculate fuel cost if needed */}
//         {hasCardPermission(user, "total_fuel_cost") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Fuel Cost</h2>
//             <p className="text-3xl font-bold text-secondary">
//               $
//               {totalCost.toLocaleString(undefined, {
//                 minimumFractionDigits: 2,
//                 maximumFractionDigits: 2,
//               })}
//             </p>
//           </div>
//         )}

//         {hasCardPermission(user, "total_scheduled_maintenances") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">
//               Scheduled Maintenance
//             </h2>
//             <p className="text-3xl font-bold text-yellow">2 Vehicles</p>
//           </div>
//         )}
//         {hasCardPermission(user, "total_upcoming_dispatches") && (
//           <div className="bg-neutral-white shadow-md rounded-lg p-6">
//             <h2 className="text-xl font-semibold mb-2">Upcoming Dispatches</h2>
//             <p className="text-3xl font-bold text-red">5 Dispatches</p>
//           </div>
//         )}
//       </div>

//       {/* Fuel Usage Analytics */}
//       {hasGraphPermission(user, "fuel_usage_analytics") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Fuel Usage Analytics
//           </h2>
//           {isLoading ? (
//             <p className="text-center">Loading fuel data...</p>
//           ) : (
//             <ResponsiveContainer width="100%" height={300}>
//               <BarChart data={fuelData}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//                 <XAxis dataKey="name" stroke="#667080" />
//                 <YAxis stroke="#667080" />
//                 <Tooltip />
//                 <Bar dataKey="fuelUsage" fill="#154469" />
//               </BarChart>
//             </ResponsiveContainer>
//           )}
//         </div>
//       )}

//       {/* Pie and Line Charts */}
//       {hasGraphPermission(user, "vehicle_status_breakdown") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Vehicle Status Breakdown
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <PieChart>
//               <Pie
//                 data={statusData}
//                 cx="50%"
//                 cy="50%"
//                 labelLine={false}
//                 label={({ name, percent }) =>
//                   `${name}: ${(percent * 100).toFixed(0)}%`
//                 }
//                 outerRadius={100}
//                 dataKey="value"
//               >
//                 {statusData.map((entry, index) => (
//                   <Cell
//                     key={`cell-${index}`}
//                     fill={COLORS[index % COLORS.length]}
//                   />
//                 ))}
//               </Pie>
//               <Tooltip />
//             </PieChart>
//           </ResponsiveContainer>
//         </div>
//       )}

//       {hasGraphPermission(user, "distance_traveled_over_time") && (
//         <div className="mb-8 bg-white shadow-md rounded-lg p-5">
//           <h2 className="text-2xl font-semibold mb-4 text-primary">
//             Distance Traveled Over Time
//           </h2>
//           <ResponsiveContainer width="100%" height={300}>
//             <LineChart data={distanceData}>
//               <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
//               <XAxis dataKey="name" stroke="#667080" />
//               <YAxis stroke="#667080" />
//               <Tooltip />
//               <Line type="monotone" dataKey="distance" stroke="#4CAF50" />
//             </LineChart>
//           </ResponsiveContainer>
//         </div>
//       )}
//     </div>
//   );
// };

// export default FleetDashboard;

import React, { useState, useMemo } from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

import useApp from "../../Hooks/useApp";
import { hasGraphPermission, hasCardPermission } from "../../Util/Permissions";
import useFuelTable from "../../Features/Tables/FuelManagement/Provider/useTable";
import useMaintenanceTable from "../../Features/Tables/Maintanance/Provider/useTable";
import useTable from "../../Features/Tables/Logistics/Provider/useTable";
import { Legend } from "recharts";

const FleetDashboard = () => {
  const { user } = useApp();
  const { docs: fuelDocs, isLoading } = useFuelTable();
  const { docs: maintenanceDocs } = useMaintenanceTable();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const filteredFuelDocs = useMemo(() => {
    if (!startDate || !endDate) return fuelDocs;
    const start = new Date(startDate);
    const end = new Date(endDate);
    return fuelDocs.filter((doc) => {
      const date = new Date(doc.fuel_date);
      return date >= start && date <= end;
    });
  }, [startDate, endDate, fuelDocs]);

  const totalFuel = useMemo(
    () =>
      filteredFuelDocs.reduce(
        (acc, doc) => acc + (Number(doc.fuel_amount) || 0),
        0
      ),
    [filteredFuelDocs]
  );

  const totalCost = useMemo(
    () =>
      filteredFuelDocs.reduce((acc, doc) => acc + (Number(doc.cost) || 0), 0),
    [filteredFuelDocs]
  );

  const fuelData = useMemo(() => {
    return filteredFuelDocs.reduce((acc, doc) => {
      const name = doc.vehicleName || doc.vehicles?.plate_no || "Unknown";
      const existing = acc.find((item) => item.name === name);
      if (existing) {
        existing.fuelUsage += Number(doc.fuel_amount) || 0;
      } else {
        acc.push({ name, fuelUsage: Number(doc.fuel_amount) || 0 });
      }
      return acc;
    }, []);
  }, [filteredFuelDocs]);

  const scheduledMaintenances = useMemo(() => {
    const today = new Date();
    return maintenanceDocs.filter((doc) => {
      const nextDate = new Date(doc.next_maintenance_date);
      return nextDate > today;
    }).length;
  }, [maintenanceDocs]);

  const statusData = [
    { name: "In Transit", value: 3 },
    { name: "Available", value: 5 },
    { name: "Maintenance", value: 2 },
  ];

  const distanceData = [
    { name: "Jan", distance: 400 },
    { name: "Feb", distance: 800 },
    { name: "Mar", distance: 600 },
    { name: "Apr", distance: 1200 },
    { name: "May", distance: 900 },
  ];

  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#AF19FF",
    "#FF4F81",
    "#FF7300",
    "#1E90FF",
    "#2E8B57",
    "#A52A2A",
  ];

  const fuelUsageData = useMemo(() => {
    const usageMap = {};
    filteredFuelDocs.forEach((doc) => {
      const vehicle = doc.vehicleName || doc.vehicles?.plate_no || "Unknown";
      usageMap[vehicle] =
        (usageMap[vehicle] || 0) + Number(doc.fuel_amount || 0);
    });
    return Object.entries(usageMap).map(([vehicle, quantity]) => ({
      name: vehicle,
      value: quantity,
    }));
  }, [filteredFuelDocs]);

  const fuelCostData = useMemo(() => {
    const costMap = {};
    filteredFuelDocs.forEach((doc) => {
      const vehicle = doc.vehicleName || doc.vehicles?.plate_no || "Unknown";
      costMap[vehicle] = (costMap[vehicle] || 0) + Number(doc.cost || 0);
    });
    return Object.entries(costMap).map(([vehicle, cost]) => ({
      name: vehicle,
      value: cost,
    }));
  }, [filteredFuelDocs]);

  const { docs: dispatchDocs } = useTable(); // pulls from logistics

  const upcomingDispatches = useMemo(() => {
    const today = new Date();
    return dispatchDocs.filter((doc) => {
      const departure = new Date(doc?.departure_date);
      return departure >= today;
    }).length;
  }, [dispatchDocs]);

  return (
    <div className="p-8 bg-light_grey">
      <h1 className="text-4xl font-bold mb-8 text-primary">Fleet Dashboard</h1>

      <div className="flex flex-wrap gap-4 mb-6 items-center">
        <label className="flex flex-col text-sm">
          From:
          <input
            type="date"
            className="p-2 border rounded"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </label>
        <label className="flex flex-col text-sm">
          To:
          <input
            type="date"
            className="p-2 border rounded"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </label>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {hasCardPermission(user, "total_fuel_usage") && (
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">Total Fuel Usage</h2>
            <p className="text-3xl font-bold text-green">
              {totalFuel.toFixed(2)} L
            </p>
          </div>
        )}

        {hasCardPermission(user, "total_fuel_cost") && (
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">Fuel Cost</h2>
            <p className="text-3xl font-bold text-secondary">
              $
              {totalCost.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        )}

        {hasCardPermission(user, "total_scheduled_maintenances") && (
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">
              Scheduled Maintenance
            </h2>
            <p className="text-3xl font-bold text-yellow">
              {scheduledMaintenances} Vehicles
            </p>
          </div>
        )}

        {hasCardPermission(user, "total_upcoming_dispatches") && (
          <div className="bg-white shadow-md rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-2">Upcoming Dispatches</h2>
            <p className="text-3xl font-bold text-red">
              {upcomingDispatches} Dispatch{upcomingDispatches !== 1 && "es"}
            </p>
          </div>
        )}
      </div>

      {hasGraphPermission(user, "fuel_usage_analytics") && (
        <div className="mb-8 bg-white shadow-md rounded-lg p-5">
          <h2 className="text-2xl font-semibold mb-4 text-primary">
            Fuel Usage Analytics
          </h2>
          {isLoading ? (
            <p className="text-center">Loading fuel data...</p>
          ) : (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={fuelData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis dataKey="name" stroke="#667080" />
                <YAxis stroke="#667080" />
                <Tooltip />
                <Bar dataKey="fuelUsage" fill="#154469" />
              </BarChart>
            </ResponsiveContainer>
          )}
        </div>
      )}

      {hasGraphPermission(user, "vehicle_status_breakdown") && (
        <div className="mb-8 bg-white shadow-md rounded-lg p-5">
          <h2 className="text-2xl font-semibold mb-4 text-primary">
            Fuel Cost by Vehicle
          </h2>
          <ResponsiveContainer width="100%" height={400}>
            <PieChart>
              <Pie
                data={fuelCostData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                outerRadius={150}
                fill="#82ca9d"
                label
              >
                {fuelCostData.map((entry, index) => (
                  <Cell
                    key={`cost-cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}

      {/* {hasGraphPermission(user, "distance_traveled_over_time") && (
        <div className="mb-8 bg-white shadow-md rounded-lg p-5">
          <h2 className="text-2xl font-semibold mb-4 text-primary">
            Distance Traveled Over Time
          </h2>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={distanceData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
              <XAxis dataKey="name" stroke="#667080" />
              <YAxis stroke="#667080" />
              <Tooltip />
              <Line type="monotone" dataKey="distance" stroke="#4CAF50" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )} */}
    </div>
  );
};

export default FleetDashboard;
